import React from "react";

function About(){
    return (
        <>
            <section id="about" className="px-8 py-[28rem] md:py-0 md:px-0 bg-gradient-to-b from-zinc-800 to-zinc-950 flex flex-col justify-center items-center lg:pt-[0rem] w-full h-screen">
                <div className="text-white text-center md:w-3/4 lg:w-3/4 mx-auto">
                    <h1 className="text-4xl font-semibold mb-8">About</h1>
                    <p className="text-md text-zinc-200">Hi, I'm Harsh, a dedicated frontend web developer passionate about crafting engaging and user-friendly digital experiences. I specialize in building responsive and visually appealing websites that leave a lasting impression. Beyond my frontend skills. I bring a depth of knowledge in Java programming and problem-solving techniques, allowing me to tackle complex challenges with ease and precision. Web development isn't just a job for me—it's a passion and a way of life. From the first line of code I wrote to the latest project I'm working on, I've always been captivated by the endless possibilities and creative freedom that web development offers. 
                    <br/><br/>
                    
                    I believe in the power of technology to drive positive change, and I'm always eager to collaborate on exciting projects that make a meaningful impact. 
                    
                    </p>
                </div>
            </section>
        </>
    )
}

export default About;
